export default class LocalStorageService {
  static setItem(name, value) {
    localStorage.setItem(name, JSON.stringify(value));
  }

  static getItem(name) {
    return JSON.parse(localStorage.getItem(name));
  }

  static removeItem(name) {
    window.localStorage.removeItem(name);
  }

  static removeAll() {
    const id = window.localStorage.getItem('typebot-id');
    window.localStorage.clear();
    if (id) {
      window.localStorage.setItem('typebot-id', id);
    }
  }

  /**
   * Function to grab one of the Cognito tokens from localStorage without needing the entire key
   * @param {string} endsWith
   */
  static getCognitoItem(endsWith) {
    for (let i = 0, l = localStorage.length; i < l; i++) {
      const key = localStorage.key(i);
      let lastElement = key.split('.').pop();

      if (lastElement === endsWith) {
        return localStorage.getItem(key);
      }
    }

    return null;
  }

  static setCognitoItem(endsWith, value) {
    for (let i = 0, l = localStorage.length; i < l; i++) {
      const key = localStorage.key(i);
      let lastElement = key.split('.').pop();

      if (lastElement === endsWith) {
        return localStorage.setItem(key, value);
      }
    }

    return null;
  }
}
